import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from "../../AbstractElements";
import EquipmentHome from "./EquipmentHome";

export default function EquipmentList() {
    const { t } = useTranslation();

    return (
        <Fragment>
            <Breadcrumbs
                mainTitle={t("List of Equipment")}
                parent={t("Home")}
                title={t("List of Equipment")}
            />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <EquipmentHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
